import style from "./TableHead.module.scss";

export function TableHead() {
    return (
        <div className={style.head}>
            <div>Дата покупки</div>
            <div>ID</div>
            <div>Оператор</div>
            <div>Тариф</div>
            <div>Термін оренди</div>
            <div>Сума</div>
        </div>
    )
}